import { scopes } from '../scopes';
import { Policy } from '../Policy';
export class CreditsPolicy extends Policy {
  oneTimeUsage() {
    return this.user.hasScope(scopes.ENRICHMENT_ONE_TIME_USAGE);
  }
  unlimitedUsage() {
    return this.user.hasScope(scopes.ENRICHMENT_UNLIMITED_USAGE);
  }
  platformAccess() {
    return this.user.hasScope(scopes.ENRICHMENT_PLATFORM_ACCESS);
  }
  viewCredits() {
    return this.platformAccess() && !this.unlimitedUsage();
  }
}